export { authStore as store } from './store'



// WEBPACK FOOTER //
// ./src/auth/index.js